/*** IMPORTS FROM imports-loader ***/
import Translator from "bazinga-translator";

(function (t) {
// xk
t.add("cart.tickets.no_available_tickets_for_seating", "Nuk ka bileta t\u00eb disponuesh\u00ebm p\u00ebr ul\u00ebset e zgjedhura", "PayseraCartBundle", "xk");
t.add("cart.tickets.no_available_tickets", "Nuk ka bileta t\u00eb disponueshme", "PayseraCartBundle", "xk");
t.add("paysera_cart.discount.invalid_code", "Kodi i pavlefsh\u00ebm i zbritjes", "PayseraCartBundle", "xk");
})(Translator);
